<!-- 1. Sign Up -->
<div class="sign-up" >
  <div class="text-18 text-semibold text-center mt-2 mb-6">Create an account</div>

  <!-- Error Message -->
  <div class="pb-2" *ngIf="errorMessage">
    <app-alert theme="light" type="danger">
      <div [innerHTML]="errorMessage"></div>
    </app-alert>
  </div>

  <!-- Group Name -->
  <div class="sign-up__group" *ngIf="groupConfig.groupCodeMode === 1">
    {{ groupConfig.group }}
  </div>

  <!-- Google -->
  <button 
    class="button button-medium button-google w-100 mb-4"
    type="button"
    (click)="handleGoogleClick()">
    <img src="/assets/images/google-icon.svg" style="width: 20px" class="mr-3">
    Continue with Google
  </button>

  <div class="divider-or mb-3">
    <div class="line"></div>
    <div class="or text-12 text-semibold text-center mv-2">OR</div>
    <div class="line"></div>
  </div>

  <form (submit)="handleFormSubmit()" [formGroup]="form" autofill="false">
    <!-- Group Code -->
    <app-form-field label="Group Code" *ngIf="groupConfig.groupCodeMode === 1">
      <input class="input w-100" name="groupCode" type="text" formControlName="groupCode">
    </app-form-field>

    <!-- Name -->
    <div class="fieldrow-50">
      <app-form-field label="First Name" class="mr-2">
        <input class="input w-100" name="firstName" type="text" formControlName="firstName" appAutoFocus>
        
        <div class="text-error text-12 mb-2" *ngIf="(firstName.dirty && firstName.touched) && firstName.invalid && (firstName.errors.required)">
          First name is required.
        </div>
      </app-form-field>

      <app-form-field label="Last Name" class="ml-2">
        <input class="input w-100" name="lastName" type="text" formControlName="lastName">

        <div class="text-error text-12 mb-2" *ngIf="(lastName.dirty && lastName.touched) && lastName.invalid && (lastName.errors.required)">
          Last name is required.
        </div>
      </app-form-field>
    </div>

    <!-- Email -->
    <app-form-field label="Email">
      <input class="input w-100" name="email" type="email" formControlName="email">

      <div class="text-error text-12 mb-2" *ngIf="(email.dirty && email.touched) && email.invalid && (email.errors.required || email.errors.email)">
        Please enter a valid email.
      </div>
    </app-form-field>

    <!-- Password -->
    <app-form-field label="Password">
      <input class="input w-100" name="password" type="password" formControlName="password" placeholder="At least 8 characters">

      <div class="text-error text-12 mb-2" *ngIf="(password.dirty && password.touched) && password.invalid && password.errors.minlength">
        Password must be at least 8 characters.
      </div>
    </app-form-field>

    <app-form-field>
      <button
        app-button 
        buttonType="primary"
        buttonSize="medium"
        class="w-100"
        type="submit">
        <span *ngIf="!(loading$ | async)">Sign Up</span>
        <app-spinner size="medium" *ngIf="loading$ | async"></app-spinner>
      </button>
    </app-form-field>
  </form>

  <div class="mt-2 text-center text-11">By signing up you agree to our <a href="https://www.biodigital.com/privacy" target="_blank">Privacy</a> and <a href="https://www.biodigital.com/terms" target="_blank">Terms</a>.</div>

  <button
    app-button
    type="button"
    buttonTheme="light"
    [uppercase]="false"
    class="w-100 mt-4"
    [routerLink]="['/login']">Have an account? Sign in</button>
</div>
